<template>
  <b-container>
    <b-row>
      <b-col class="m-3">
        <b-card class="w-100 shadow" :title="isAdd ? 'ایجاد سرفصل' : 'ویرایش سرفصل'">
          <b-overlay :show="loading" rounded opacity="0.6" spinner-large spinner-variant="info"
            class="d-inline-block w-100" @hidden="!loading">
            <b-row>
              <b-col md="12">
                <label for="input_title" class="text-right w-100 mt-3 required-label">عنوان سرفصل</label>
                <b-form-input type="text" v-model="topic.title" id="input_title" placeholder="ورود سرفصل یا موضوع"
                  class="rtl"></b-form-input>
              </b-col>
              <b-col md="12">
                <label for="input_description" class="text-right w-100 mt-3">توضیحات</label>
                <b-form-textarea id="input_description" v-model="topic.description" placeholder="ورود توضیحات" rows="1"
                  max-rows="2" class="rtl" no-resize></b-form-textarea>
              </b-col>
              <b-col md="6">
                <label for="input_description" class="text-right w-100 mt-3">ترتیب</label>
                <b-form-input type="text" v-model="topic.order" id="input_order" placeholder="ورود ترتیب" class="rtl">
                </b-form-input>
              </b-col>
            </b-row>
            <div v-if="!isAdd" class="mt-5">
              <b-button v-if="!topic.is_deleted" variant="outline-danger" size="sm" class="mt-2 d-block"
                @click="doRemove" :disabled="loading">
                <b-icon icon="trash" class="m-1"></b-icon>حذف کردن
              </b-button>
              <b-button v-if="topic.is_deleted" variant="outline-secondary" class="mt-2 d-block" size="sm"
                @click="topic.is_deleted = false">
                <b-icon icon="hand-thumbs-up" class="m-1" :disabled="loading"></b-icon>برگرداندن از حالت حذف شده - جهت
                تایید
                نهایی ، دکمه ی ثبت را
                بزنید
              </b-button>
              <b-button v-if="!topic.is_hidden" variant="outline-danger" size="sm" class="mt-2 d-block" @click="doHide"
                :disabled="loading" title="مخفی کردن سرفصل به معنای عدم نمایش سرفصل در پنل کاربر می باشد">
                <b-icon icon="trash" class="m-1"></b-icon> مخفی
                کردن
              </b-button>
              <b-button v-if="topic.is_hidden" variant="outline-secondary" class="mt-2 d-block" size="sm"
                @click="topic.is_hidden = false">
                <b-icon icon="hand-thumbs-up" class="m-1" :disabled="loading"></b-icon>برگرداندن از حالت مخفی - جهت
                تایید
                نهایی ، دکمه ی ثبت را
                بزنید
              </b-button>
              <p v-if="topic.is_hidden" class="text-secondary text-right">
                این کلیدواژه مخفی شده است
              </p>
            </div>

            <b-button variant="info" class="mx-auto w-25 mt-3" @click="doAddOrEdit" :disabled="loading">
              <span v-if="isAdd">ایجاد</span>
              <span v-else>ثبت</span>
            </b-button>
            <b-button variant="outline-info" class="mx-auto mt-3" @click="$router.go(homeIndex)" :disabled="loading">
              بازگشت
            </b-button>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import _ from "lodash";

export default {
  name: "TopicAddEdit",
  data: () => ({
    loading: false,
    isAdd: true,
    homeIndex: -1,
    topic_id: null,
    topic: {
      title: "",
      description: "",
      order: 1,
      is_hidden: false,
      is_deleted: false
    },
  }),
  created() {
    if (this.$route.query.home_index) {
      this.homeIndex = parseInt(this.$route.query.home_index);
    }
    //populate ui for edit
    this.topic_id = this.$route.params.topic_id;
    if (this.topic_id) {
      this.isAdd = false;

      this.loading = true;
      this.$axios
        .get("/topics/" + this.topic_id)
        .then((response) => {
          const body = response.data;

          this.topic = _.pick(body.data, [
            "title",
            "description",
            "is_hidden",
            "is_deleted",
            "order",
          ]);
        })
        .catch((err) => {
          this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    doRemove() {
      this.$bvModal
        .msgBoxConfirm("آیا از حذف " + this.topic.title + " اطمینان دارید؟", {
          title: "توجه",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "بله",
          cancelTitle: "بستن",
          bodyClass: "text-right",
          headerClass: "text-danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((result) => {
          if (result) {
            this.loading = true;
            this.$axios
              .delete("/topics/" + this.topic_id)
              .then(() => {
                this.$bvToast.toast("سرفصل با موفقیت حذف شد", {
                  variant: "success",
                  title: "هورا",
                });
                setTimeout(() => {
                  this.$router.go(this.homeIndex);
                }, 1000);
              })
              .catch((err) => {
                this.$bvToast.toast(err.text, {
                  variant: "danger",
                  title: "خطا",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    doHide() {
      this.$bvModal
        .msgBoxConfirm("آیا از مخفی کردن " + this.topic.title + " اطمینان دارید؟", {
          title: "توجه",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "بله",
          cancelTitle: "بستن",
          bodyClass: "text-right",
          headerClass: "text-danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((result) => {
          if (result) {
            this.loading = true;
            this.$axios
              .post("/topics/hide/" + this.topic_id)
              .then(() => {
                this.$bvToast.toast("سرفصل با موفقیت مخفی شد", {
                  variant: "success",
                  title: "هورا",
                });
                setTimeout(() => {
                  this.$router.go(this.homeIndex);
                }, 1000);
              })
              .catch((err) => {
                this.$bvToast.toast(err.text, {
                  variant: "danger",
                  title: "خطا",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    doAddOrEdit() {
      if (this.topic.title == "" || !this.topic.title) {
        return this.$bvToast.toast("فیلد عنوان الزامی است", {
          variant: "danger",
          title: "خطا",
        });
      }

      this.loading = true;
      if (this.isAdd) {
        this.$axios
          .post("/topics", this.topic)
          .then((response) => {
            if (response.status == 208) {
              //means duplicate content
              const body = response.data;
              let message =
                "سرفصل ی فوق تکراری است، می توانید آن را ویرایش کنید";
              if (body.data.is_hidden) {
                message =
                  "سرفصل ی فوق مخفی شده است و مجددا در حال ایجاد آن هستید";
              }
              this.$bvToast.toast(message, {
                variant: "warning",
                title: "توجه",
                href: this.$router.resolve({
                  name: "EditTopic",
                  params: { topic_id: body.data._id },
                  query: { home_index: -2 },
                }).href,
              });
            } else {
              this.$bvToast.toast("سرفصل با موفقیت ایجاد شد", {
                variant: "success",
                title: "هورا",
              });
              this.$router.go(this.homeIndex);
            }
          })
          .catch((err) => {
            this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$axios
          .put("/topics/" + this.topic_id, this.topic)
          .then((response) => {
            if (response.status == 208) {
              //means duplicate content
              const body = response.data;
              this.$bvToast.toast(
                "سرفصل فوق تکراری است، می توانید آن را ویرایش کنید",
                {
                  variant: "warning",
                  title: "توجه",
                  href: this.$router.resolve({
                    name: "EditTopic",
                    params: { topic_id: body.data._id },
                    query: { home_index: -2 },
                  }).href,
                }
              );
            } else {
              this.$bvToast.toast("سرفصل با موفقیت ویرایش شد", {
                variant: "success",
                title: "هورا",
              });
              this.$router.go(this.homeIndex);
            }
          })
          .catch((err) => {
            this.$bvToast.toast(err.text, { variant: "danger", title: "خطا" });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>